import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BarChart2, Users, Activity } from 'lucide-react';

const REPORTS = [
  {
    path: '/admin/reports/daily-summary',
    title: 'Resumen diario de uso',
    description: 'Solicitudes, operaciones y facturas por usuario, RFC y operación agrupadas por día.',
    icon: BarChart2,
  },
  {
    path: '/admin/reports/monthly-rfc-usage',
    title: 'RFCs únicos por mes',
    description: 'Cantidad de RFCs distintos utilizados por cada usuario en el mes, basado en DailySummaries.',
    icon: Users,
  },
  {
    path: '/admin/stripe-events',
    title: 'Eventos de Stripe',
    description: 'Webhooks recibidos de Stripe con resolución de cliente y suscripción para diagnóstico.',
    icon: Activity,
  },
];

const AdminReports = () => {
  const navigate = useNavigate();

  return (
    <div className="status-container">
      <div className="page-header mb-4">
        <div>
          <h2 className="page-title">Reportes</h2>
          <p className="page-subtitle text-muted">Selecciona un reporte para consultarlo.</p>
        </div>
      </div>

      <Row className="g-3">
        {REPORTS.map((report) => {
          const Icon = report.icon;
          return (
            <Col key={report.path} xs={12} md={4}>
              <Card
                className="h-100 border"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(report.path)}
              >
                <Card.Body className="d-flex gap-3 align-items-start">
                  <Icon size={28} className="text-primary mt-1 flex-shrink-0" />
                  <div>
                    <Card.Title style={{ fontSize: '1rem' }}>{report.title}</Card.Title>
                    <Card.Text className="text-muted small">{report.description}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default AdminReports;
